import withContentFlags from '@/hoc/withContentFlags';
import Div from '@/shared/Div';
import React, { useCallback } from 'react';
import Map from '../Map';
import dlv from 'dlv';
import Container from '@/shared/Container';
import MenuNav from '@/shared/crisp/MenuNav';
import { getCategoryURL } from '@/utils/urls';

interface CategoriesProps {
  list: { data: any[] };
  title: string;
}

const Categories: React.FC<CategoriesProps> = ({ list, title }) => {
  const render = useCallback((item: any, index: number) => {
    const { name, icon, categoryId } = dlv(item, 'attributes', {});
    return (
      <MenuNav
        key={categoryId}
        label={name}
        image={icon.data.attributes.url}
        href={getCategoryURL(categoryId)}
      />
    );
  }, []);
  return (
    <Div className="bg-cs-secondary py-8">
      <Container className="text-cti-primary text-center ">
        <Div className="text-h-1 mb-6" dangerouslySetInnerHTML={{ __html: title }} />
        <Map className="flex justify-center flex-wrap" list={list.data} render={render} />
      </Container>
    </Div>
  );
};

export default withContentFlags(Categories);
